import React from 'react';
import { motion } from 'framer-motion';
interface ProductImageProps {
  className?: string;
}
export function ProductImage({
  className = ''
}: ProductImageProps) {
  const handleClick = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.div onClick={handleClick} whileHover={{
    scale: 1.02,
    y: -5
  }} className={`cursor-pointer relative group mx-auto ${className}`} data-id="element-104">
      <div className="absolute inset-0 bg-teal-500/20 blur-[100px] rounded-full group-hover:bg-teal-400/30 transition-colors duration-500" data-id="element-105"></div>
      <img src="https://cdn.magicpatterns.com/uploads/5fXwkGWeE8sCxL3az5JZSZ/TRANSFORMA_TU_PRACTICA_ORTOPEDICA_AL_SIGUIENTE_NIVEL_(1).png" alt="Kit Ortopedista Pro" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-106" />
    </motion.div>;
}